import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../common/material/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../app-routing.module';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from '../common/pipe/pipe.module';
import { DashboardBedienungsanleitungComponent } from './dashboard-bedienungsanleitung/dashboard-bedienungsanleitung.component';
import { DashboardDatenaktualisierungComponent } from './dashboard-datenaktualisierung/dashboard-datenaktualisierung.component';
import { DashboardNetzzuordnungenComponent } from './dashboard-netzzuordnungen/dashboard-netzzuordnungen.component';
import { DashboardUuidChangeConfirmationComponent } from './dashboard-uuid-change-confirmation/dashboard-uuid-change-confirmation.component';
import { DashboardPlanwerteComponent } from './dashboard-planwerte/dashboard-planwerte.component';
import {
    DashboardNetzzuordnungenImportComponent,
} from './dashboard-netzzuordnungen-import/dashboard-netzzuordnungen-import.component';
import {
    DashboardUnbestaetigteUuidsComponent,
} from './dashboard-unbestaetigte-uuids/dashboard-unbestaetigte-uuids.component';
import {
    DashboardDienstleistungsartenComponent,
} from './dashboard-dienstleistungsarten/dashboard-dienstleistungsarten.component';

@NgModule({
    declarations: [
        DashboardPageComponent,
        DashboardBedienungsanleitungComponent,
        DashboardNetzzuordnungenComponent,
        DashboardDatenaktualisierungComponent,
        DashboardUuidChangeConfirmationComponent,
        DashboardPlanwerteComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        PipeModule,
        DashboardNetzzuordnungenImportComponent,
        DashboardUnbestaetigteUuidsComponent,
        DashboardDienstleistungsartenComponent,
    ],
})
export class DashboardModule {
}
